<template>
  <FormItem :name="name">
    <textarea
      v-model.trim="model"
      :rows="rows"
      :cols="cols"
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder"
    ></textarea>
  </FormItem>
</template>

<script setup lang="ts">
import FormItem from './Form-item.vue'
const props = defineProps({
  name: { type: String, required: true },
  placeholder: { type: String },
  disabled: { type: Boolean },
  readonly: { type: Boolean },
  rows: { type: Number, default: 5 },
  cols: { type: Number }
})

const model = defineModel<any>({ required: true })
</script>

<style lang="css" scoped>
textarea {
  width: 100%;
}
</style>
